// Shared analytics helpers for the quiz-result pages.
// The A/B test is over: every completed quiz opens /quiz-result/, which is the
// former /quiz-result-v2/ (it still tracks as variant "b" / page_version "v2",
// so its numbers continue the test data). The old page is kept at
// /quiz-result-v1/ ("a" / "v1") and /quiz-result-v3/ ("c" / "v3") stays
// reachable by URL, but neither is drawn any more.
// Every event carries variant and page_version, so the pages can be compared.

// Path of the result page for a child.
export const quizResultPath = (childId) => `/quiz-result/?childId=${childId}`;

export const createTracker = (variant, pageVersion) => {
  const push = (event, params = {}) => {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      ...params,
      variant,
      page_version: pageVersion,
    });
  };
  return {
    view: (params) => push("quiz_result_view", params),
    ctaClick: (placement) => push("quiz_result_cta_click", { placement }),
    storeClick: (store, placement) =>
      push("quiz_result_store_click", { store, placement }),
    sectionView: (section) => push("quiz_result_section_view", { section }),
    chip: (difficulty) =>
      push("quiz_result_difficulty_chip_click", { difficulty }),
    faqOpen: (question) => push("quiz_result_faq_open", { question }),
    scrollDepth: (depth) => push("quiz_result_scroll_depth", { depth }),
  };
};

// 25 / 50 / 75 / 100 % scroll depth, once each. Returns a cleanup function.
export const watchScrollDepth = (onDepth) => {
  const fired = new Set();
  const onScroll = () => {
    const doc = document.documentElement;
    const max = doc.scrollHeight - window.innerHeight;
    if (max <= 0) return;
    const pct = (window.scrollY / max) * 100;
    [25, 50, 75, 100].forEach((d) => {
      if (pct >= d - 0.5 && !fired.has(d)) {
        fired.add(d);
        onDepth(d);
      }
    });
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  return () => window.removeEventListener("scroll", onScroll);
};

export const storeFromLabel = (label = "") =>
  /App Store/.test(label) ? "ios" : /Google Play/.test(label) ? "android" : null;
